<template>
  <tbody v-if="driver">
    <tr>
      <td>
        <v-checkbox
          class="my-0"
          v-model="driver.selected"
          style="float: left"
        />
      </td>
      <!-- <td>
        <v-img
          v-if="driver.pic"
          :src="driver.pic"
          style="border-radius: 100px; width: 50px; height: 50px"
        ></v-img>
      </td> -->
      <td>{{ driver.name }}</td>
      <td>+{{ driver.countryCode }}-{{ driver.phone }}</td>
      <td>
        {{
          driver.type == 1 ? "Driver" : driver.type == 2 ? "Helper" : "Employee"
        }}
      </td>
      <td>{{ driver.corpName }}</td>
      <td>{{ driver.zoneName }}</td>
      <td>
        <v-chip
          v-if="driver.compliant == 1"
          small
          color="green"
          text-color="white"
          >Compliance Done</v-chip
        >
        <v-chip
          v-if="driver.compliant == 2"
          small
          color="red"
          text-color="white"
          >Not Compliant</v-chip
        >
        <v-chip small v-if="driver.compliant == 3">Compliance Due</v-chip>
      </td>
      <td>
        <span v-if="driver.lastLogin">{{
          driver.lastLogin | moment("HH:mm DD MMM")
        }}</span>
      </td>
      <td>
        <v-chip v-if="driver.onDuty" small color="green" text-color="white"
          >On Duty</v-chip
        >
        <v-chip v-else small color="orange" text-color="white">Off Duty</v-chip>
        <br />
        <v-icon v-if="driver.powerSaver">mdi-map-marker-off</v-icon>
      </td>
      <td>
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Driver ?')"
          @click="deleteDriver(driver._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <!-- <v-btn class="float-right" text fab x-small color="grey" :to="'/driver/' + driver._id">
          <v-icon>mdi-timetable</v-icon>
        </v-btn>-->
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="success"
          v-if="showSelectBtn"
          @click="select"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          v-if="!singlePage"
          :to="'/driver/' + driver._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          v-if="singlePage"
          @click="editDriver"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>

  <!-- <v-card-text class="py-0" v-if="driver">
    <v-row>
      <v-col cols="12" xs="11" sm="12" md="10" lg="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="5" lg="5" class="body-2">
            <v-row>
              <v-col cols="12" xs="13" sm="2" md="1" lg="1" class="body-2">
                <v-checkbox class="my-0" v-model="driver.selected" style="float:left" />
              </v-col>

              <v-col cols="12" xs="3" sm="3" md="3" class="body-2">
                <v-img
                  v-if="driver.pic"
                  :src="driver.pic"
                  style="border-radius:100px;width:50px;height:50px;"
                ></v-img>
              </v-col>

              <v-col cols="12" xs="3" sm="4" md="8" class="body-2">
                <b>{{driver.name}}</b>
                <br />
                {{driver.countryCode}} {{driver.phone}}
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="3" lg="3" class="body-2">{{driver.corpName}}</v-col>
          <v-col cols="12" xs="12" sm="6" md="2" lg="2" class="body-2">
            {{driver.zoneName}}
            <br v-if="driver.zoneName" />
            <v-chip
              v-if="driver.compliant == 1"
              small
              color="green"
              text-color="white"
            >Compliance Done</v-chip>
            <v-chip v-if="driver.compliant == 2" small color="red" text-color="white">Not Compliant</v-chip>
            <v-chip small v-if="driver.compliant == 3">Compliance Due</v-chip>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="2" lg="2" class="body-2">
            {{driver.lastLogin | moment("HH:mm DD MMM YYYY")}}
            <br />
            <v-chip v-if="driver.onDuty" small color="green" text-color="white">On Duty</v-chip>
            <v-chip v-else small color="orange" text-color="white">Off Duty</v-chip>
            <br />
            <v-icon v-if="driver.powerSaver">mdi-map-marker-off</v-icon>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="1" sm="12" md="2" lg="2" class="text-center pl-0">
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Driver ?')"
          @click="deleteDriver(driver._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn class="float-right" text fab x-small color="blue" :to="'/driver/' + driver._id">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>-->
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "DriverRow",
  props: {
    value: {
      default: null,
    },
    selected: {
      default: false,
    },
    refresh: {
      default: null,
    },
    payload: {
      default: null,
    },
    showSelectBtn: {
      default: false,
    },
    singlePage: {
      default: false,
    },
  },
})
export default class DriverRow extends Vue {
  driver = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  editDriver() {
    this.$emit("driverEdit", this.driver._id);
  }

  select() {
    this.$emit("select", this.driver);
  }

  async deleteDriver(driver_id) {
    common.setLoading(true);
    try {
      await doGet("/api/driver/delete/" + driver_id);
      common.showMessage("Deleted Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.driver = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.driver = val;
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.driver.selected = val;
  }
}
</script>
